import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Modal from 'react-modal';
import { AiOutlineClose } from 'react-icons/ai'
import { Link } from "react-router-dom";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '1px solid #e4e4e7',
        borderRadius: '0.5rem',
        boxShadow: '0 24px 80px rgba(24, 24, 27, 0.18)',
        padding: '2rem',
        maxWidth: 'min(90vw, 560px)',
        width: '100%',
    },
    overlay: {
        backgroundColor: 'rgba(24, 24, 27, 0.48)',
        backdropFilter: 'blur(4px)',
        zIndex: 50,
    },
};

export const ContactForm = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_qpoki0m', 'template_tqep1yw', form.current, 'Ek8m9YMYYi0hXmU-p')
            .then((result) => {
                console.log(result.text);
                openModal();
            }, (error) => {
                console.log(error.text);
                errorOpenModal();
            });
    };

    Modal.setAppElement('#root');

    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#f00';
    }

    function closeModal() {
        setIsOpen(false);
    }

    const [errorModalIsOpen, errorSetIsOpen] = React.useState(false);

    function errorOpenModal() {
        errorSetIsOpen(true);
    }

    function errorCloseModal() {
        errorSetIsOpen(false);
    }

    return (
        <div>
            <form className='flex flex-col gap-5' ref={form} onSubmit={sendEmail}>
                <div>
                    <label className='text-sm font-semibold uppercase tracking-[0.16em] text-zinc-600'>Name</label>
                    <input placeholder='John Smith' className='mt-2 block w-full rounded-md border border-zinc-200 bg-zinc-50 px-4 py-3 text-base text-zinc-900 shadow-sm transition placeholder:text-zinc-400 hover:border-zinc-300 focus:border-red-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-red-500/20' type="text" required name="from_name" />
                </div>
                <div>
                    <label className='text-sm font-semibold uppercase tracking-[0.16em] text-zinc-600'>Email</label>
                    <input placeholder='johnsmith@email.com' className='mt-2 block w-full rounded-md border border-zinc-200 bg-zinc-50 px-4 py-3 text-base text-zinc-900 shadow-sm transition placeholder:text-zinc-400 hover:border-zinc-300 focus:border-red-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-red-500/20' type="email" required name="email_id" />
                </div>
                <div>
                    <label className='text-sm font-semibold uppercase tracking-[0.16em] text-zinc-600'>Message</label>
                    <textarea placeholder='Type your message to Cedonia here!' rows="5" className='mt-2 block w-full resize-none rounded-md border border-zinc-200 bg-zinc-50 px-4 py-3 text-base text-zinc-900 shadow-sm transition placeholder:text-zinc-400 hover:border-zinc-300 focus:border-red-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-red-500/20' name="message" required />
                </div>
                <input className='mt-1 cursor-pointer rounded-md bg-red-600 px-5 py-3 text-base font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2' type="submit" value="Send" />
            </form>

            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className='flex flex-col'>
                    <h2 className='text-2xl font-bold text-red-600' ref={(_subtitle) => (subtitle = _subtitle)}>Email Sent</h2>
                    <button className='absolute right-4 top-4 rounded-full p-2 transition hover:bg-zinc-100' onClick={closeModal}><AiOutlineClose className='text-zinc-900' size={"1.5em"} /></button>
                    <div className='py-12'>
                        <h2 className='text-xl leading-8 text-zinc-900'>Cedonia will send you an email back in the next few business days.</h2>
                    </div>
                    <div className='flex flex-wrap justify-center gap-5 border-t border-zinc-200 pt-5 text-sm font-semibold text-zinc-700'>
                        <Link className='transition hover:text-red-500' to="/">Home</Link>
                        <Link className='transition hover:text-red-500' to="/about">About</Link>
                        <Link className='transition hover:text-red-500' to="/quality">Quality</Link>
                        <Link className='transition hover:text-red-500' to="/services">Services</Link>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={errorModalIsOpen}
                onRequestClose={errorCloseModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className='flex flex-col'>
                    <h2 className='text-2xl font-bold text-red-600' ref={(_subtitle) => (subtitle = _subtitle)}>Email Was Not Sent</h2>
                    <button className='absolute right-4 top-4 rounded-full p-2 transition hover:bg-zinc-100' onClick={errorCloseModal}><AiOutlineClose className='text-zinc-900' size={"1.5em"} /></button>
                    <div className='py-12'>
                        <h2 className='text-xl leading-8 text-zinc-900'>Please try again or feel free to give us a phone call.</h2>
                    </div>
                    <div className='flex flex-wrap justify-center gap-5 border-t border-zinc-200 pt-5 text-sm font-semibold text-zinc-700'>
                        <Link className='transition hover:text-red-500' to="/">Home</Link>
                        <Link className='transition hover:text-red-500' to="/about">About</Link>
                        <Link className='transition hover:text-red-500' to="/quality">Quality</Link>
                        <Link className='transition hover:text-red-500' to="/services">Services</Link>
                    </div>
                </div>
            </Modal>
        </div >
    );
};
